<template>
  <div
    :class="{ 'bg-white': !nightMode, 'bg-dark': nightMode }"
    class="pt-5 p-st"
  >
    <!-- <navigation></navigation> -->
    <nav id="navbar_container" class="navbar fixed-top navbar-expand-md">
      <a class="navbar-brand" href="/#Profile"> Dang Tran </a>
      <div class="collapse navbar-collapse">
        <ul class="navbar-nav ml-auto">
          <li class="nav-item">
            <a class="nav-link" href="/#Profile">Home</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" href="/#News">News</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" href="/#Publications">Publications</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" href="/#Experiences">Experiences</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" href="/#Projects">Projects</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" href="#">Blogs</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" href="/#Contact">Contact</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" v-bind:href="github_link">Github</a>
            <!-- TODO: Add icon for the github instead -->
          </li>
        </ul>
      </div>
      <h1>Blogs</h1>
    </nav>
    <br />
    <div class="container">
      <div class="text-center">
        <h1>Homogeneous Transformation with ROS<i>tf</i></h1>
      </div>
      <div class="text-left">
        <article>
          <h2>Vector Translation Representation</h2>
          <p>
            Translation vector can be represented as
            <VueLatex expression="p_{01}" display-mode />
            where <VueLatex expression="\{0\}" /> is the basis,
            <VueLatex expression="1" /> is the point name.
          </p>
          <p>
            We can also interpret <VueLatex expression="p_{01}" /> as a vector
            have start position <VueLatex expression="0" /> and end position
            <VueLatex expression="1" />
          </p>

          <h2>Homogeneous Transformation Representation</h2>
          <p>
            <!-- <textarea v-model="formula" /> -->
            First, homogenous transformation can be represented in the form
            <VueLatex expression="T_{10}" display-mode />
            where <VueLatex expression="\{1\}" /> is the target basis,
            <VueLatex expression="\{0\}" /> is the base basis.

            <VueLatex expression="p_1=T_{10} \cdot p_0" display-mode />
          </p>
          <p>We can get the equivalent presentation using syntax</p>


          <h2>Application</h2>
          <h3>Find rotation of Robot</h3>



      </div>
    </div>

    <!-- <div class="container-fluid">
    </div> -->
  </div>
</template>

<script>
import Navigation from "../components/Navigation.vue";
import { VueLatex } from "vatex";
export default {
  name: "Blog",
  components: {
    Navigation,
    VueLatex,
  },
  // data() {
  //   return {
  //     formula: "$$x = {-b \\pm \\sqrt{b^2-4ac} \\over 2a}.$$",
  //   };
  // },
};
</script>

<style scoped>
#page {
  background-color: rgb(24, 26, 27);
  color: white;
}
#navbar_container {
  background-color: rgb(18, 44, 86);

  padding-left: 40px;
  padding-right: 10px;
}

.navbar-brand {
  color: white;
}

.nav-link {
  color: white;
}

.navbar-brand:hover {
  color: rgb(224, 231, 14);
}
.nav-link:hover {
  color: rgb(224, 231, 14);
}

.navbar-brand:focus {
  color: rgb(224, 231, 14);
}
.nav-link:focus {
  color: rgb(224, 231, 14);
}

#Profile {
  padding-top: 80px;
}

#profile_image {
  padding-top: 40px;
}

#brief_profile_description {
  text-align: center;
  line-height: 3px;
}

#author {
  background-color: rgb(225, 72, 16);
}

.home_title {
  font-size: 28px;
  font-weight: 500;
}
</style>

